export const SELECT_CLIENT = 'SELECT_CLIENT';

export const selectClient = client => ({
  type: SELECT_CLIENT,
  client,
});
